import { useEffect, useState } from 'react'
import { Fade, styled } from '@mui/material'
import { NAV, HEADER } from '../../../config-global'
import { useSettingsContext } from '../../../components/settings'
import Image from '../../../components/image'

const StyledRoot = styled('div')(({ theme }) => ({
    right: 0,
    bottom: 0,
    zIndex: 9998,
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
}))

export default function TransitionPage() {

    const [type, setType] = useState('in')
    const [time, setTime] = useState(500)

    const isDashboard = false

    const { themeLayout } = useSettingsContext()

    const size =
        (themeLayout === 'mini' && NAV.W_DASHBOARD_MINI) ||
        (themeLayout === 'vertical' && NAV.W_DASHBOARD) || 144

    useEffect(() => {
        setTimeout(() => {
            setType('out')
            setTime(2000)
        }, 500)
        // eslint-disable-next-line
    }, [])

    return (
        <Fade in={type === 'in'} out={type === 'out'} timeout={time}>
            <StyledRoot
                sx={{
                    ...(isDashboard && {
                        width: `calc(100% - ${size}px)`,
                        height: `calc(100% - ${HEADER.H_DASHBOARD_DESKTOP}px)`,
                        ...(themeLayout === 'horizontal' && {
                            width: 1,
                            height: `calc(100% - ${size}px)`,
                        }),
                    }),
                }}
            >
                <Image
                    disabledEffect
                    sx={{ height: 160, opacity: 0.3 }}
                    src='/logo/logo_md.png'
                />
            </StyledRoot>
        </Fade>
    )
}